import type { AppSettings } from './appSettings';

export const APP_SETTINGS_URL = 'assets/app-setting.json';

let preloadedAppSettings: AppSettings | null = null;

/**
 * Loads the runtime configuration before Angular starts, outside the HTTP interceptor chain.
 * Resolves to null on failure so the existing APP_INITIALIZER load keeps its current failure behavior.
 */
export async function preloadAppSettings(): Promise<AppSettings | null> {
  try {
    const response = await fetch(APP_SETTINGS_URL, { cache: 'no-cache', credentials: 'same-origin' });
    if (!response.ok) {
      return null;
    }
    preloadedAppSettings = (await response.json()) as AppSettings;
    return preloadedAppSettings;
  } catch {
    return null;
  }
}

export function getPreloadedAppSettings(): AppSettings | null {
  return preloadedAppSettings;
}
